import React from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../BreadcrumbArea/BreadcrumbArea";
import { Link } from "react-router-dom";
function PackageGold() {
  return (
    <section className="about-area my-5">
      <div className="container custom-container">
        <div className="about-inner">
          <div className="row align-items-center justify-content-center">
            <div className="col-46 order-0 order-lg-2">
              <div className="about-img text-end">
                <div className="combo-div">
                  <h3 className="h3 display-6 text-white fw-bold">
                    Gold Packages
                  </h3>
                  <h3 className="h5 text-white fw-bold">
                  Complete Branding Solutions
                  </h3>
                  <h2 className="display-3 text-white font-bold fw-bold">
                  <span className="display-4">$</span>1499
                  </h2>
                  <div className="combo-div-one">Starting From</div>
                  <div
                    className="bg-white w-full d-flex justify-content-center p-4 fs-1 fw-bold text-dark"
                    style={{ width: "100%" }}
                  >
                    20% OFF Next Order
                  </div>
                  <div
                    className="row text-white text-start px-4"
                    style={{ width: "100%" }}
                  >
                    <div
                      className="col-sm-6"
                      style={{ borderRight: "2px solid white" }}
                    >
                      <div className="fs-5"></div>
                      <div className="text-center">
                        <div>Speak with us</div>
                        <div className="fw-bold">+61485972839 / +61480008440</div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=""></div>
                      <div className="text-center">
                        <div>Want to Discuss?</div>
                        <div className="fw-bold">Live Chat</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-54">
              <div className="about-content">
                <div className="section-title mb-25">
                  <span className="sub-title m-0">Gold</span>
                  <h2 className="" style={{ fontSize: "5rem" }}>
                    COMBO
                  </h2>
                </div>
                <p>Ultimate Value for Start-ups and Businesses</p>
                <ul
                  className="row custom-list-1"
                  style={{ flexDirection: "row" }}
                >
                  <li className="col-sm-6 combo-list">
                    <div className="content">
                      <h4 className="title">Logo Design</h4>
                      <ul className="custom-list">
                        <li>8 Concepts</li>
                        <li>Unlimited Revisions</li>
                        <li>4 Dedicated Designers</li>
                        <li>Turnaround 24-48hrs</li>
                        <li>All Formats included</li>
                        <li>Stationery Design</li>
                        <li>Business Card Design</li>
                        <li>Letterhead Design</li>
                        <li>Envelope Design</li>
                        <li>Email Signature Design</li>
                      </ul>
                    </div>
                  </li>
                  <li className="col-sm-6 combo-list">
                    <div className="content">
                      <h4 className="title">Website Design</h4>
                      <ul className="custom-list">
                        <li>E-Commerce Website</li>
                        <li>8 Pages Custom Design</li>
                        <li>Content Management System (CMS) Integration</li>
                        <li>Contact Us Form</li>
                        <li>Search Engine Submission</li>
                        <li>Cross Browsers Compatibility</li>
                        <li>Unlimited Email Addresses</li>
                        <li>W3C Certified HTML</li>
                      </ul>
                    </div>
                  </li>
                  <li className="col-sm-6 combo-list mt-3">
                    <div className="content">
                      <h4 className="title">Social Media Design</h4>
                      <ul className="custom-list">
                        <li>Any 4 of Your Choice</li>
                        <li>Facebook, LinkedIn, G+, Twitter, YouTube</li>
                      </ul>
                    </div>
                  </li>
                  <li className="col-sm-6 combo-list mt-3">
                    <div className="content">
                      <h4 className="title">SEO Optimization</h4>
                      <ul className="custom-list">
                        <li>1 Month SEO</li>
                        <li>Optimized webpages for ranking</li>
                        <li>
                          A+ Content on the website using high traffic keywords
                        </li>
                        <li>Backlinking, Meta Tags and much more</li>
                      </ul>
                    </div>
                  </li>
                </ul>

                <div className="about-content-bottom">
                  <span>Think Innovatix Hub Are a Full Service Design</span>
                  <div className="read-more-btn">
                    <Link to="/contact" className="btn">
                      Contact Us<span></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PackageGold;
